import React from "react";
import { Redirect } from "react-router-dom";
import QueryLoading from "../components/animations/QueryLoading";
import Login from "../components/loginpage/Login";
import get from "lodash.get";

const LoginPage = ({ userLoading, userData, refetchUser, location }) => {
  if (userLoading) {
    return <QueryLoading />;
  }

  if (userData) {
    return <Redirect to={get(location, "state.reRoute", "/")} />;
  }
  return <Login refetchUser={refetchUser} />;
};

export default LoginPage;
